var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"tile is-child card"},[_c('header',{class:_vm.panelClasses},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"notification"},[_c('p',[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }